<tt-page *ngIf="!!get && !!params">
    <div class="col-xs-12 sp-0">
        <div class="col-xs-12 col-md-3 sp-0">
            <tt-card class="col-xs-12 p-4">
                <tt-input ttLabel="kpicomp_keyno" [(ttModel)]="get.kpicomp_keyno" ttReadonly></tt-input>
                <tt-input ttLabel="kpicomp_name" [(ttModel)]="get.kpicomp_name">
                    <ng-container buttons *ngIf="'' + params.kpicomp_keyno > '0'">
                        <tt-form-field-button ttIcon="fas fa-language" (ttClick)="openTranslateDialog(get.kpicomp_name_word_id, get.kpicomp_name)"></tt-form-field-button>
                    </ng-container>
                </tt-input>
                <tt-input ttLabel="kpicomp_description" [(ttModel)]="get.kpicomp_description">
                    <ng-container buttons *ngIf="'' + params.kpicomp_keyno > '0'">
                        <tt-form-field-button ttIcon="fas fa-language" (ttClick)="openTranslateDialog(get.kpicomp_description_word_id, get.kpicomp_description)"></tt-form-field-button>
                    </ng-container>
                </tt-input>
                <tt-color-input ttLabel="tile_background_color" [(ttModel)]="get.tile_background_color" ttDebounceTime="50"></tt-color-input>
                <tt-input ttLabel="data1_text" [(ttModel)]="get.data1_text"></tt-input>
                <tt-select ttLabel="p2_webpage" [(ttModel)]="get.p2_webpage_keyno" [ttData]="webpages"></tt-select>
                <!-- <tt-search-multi-select ttModelSetting="object" ttLabel="webpages" [(ttModel)]="get.webpages" [ttData]="searchWebpages"></tt-search-multi-select> -->
                <tt-input [hidden]="get.kpicomp_type === 'GRID'" ttLabel="proc_name" [(ttModel)]="get.proc_name"></tt-input>
                <tt-checkbox ttLabel="is_public" [(ttModel)]="get.is_public"></tt-checkbox>
                <tt-select ttLabel="kpicomp_type" [(ttModel)]="get.kpicomp_type" [ttData]="kpiTypes" ttDataId="color_id" ttDataName="color_name"></tt-select>
                <tt-input-number [hidden]="get.kpicomp_type !== 'GRID'" ttLabel="p2_datatask_keyno" [(ttModel)]="get.p2_datatask_keyno"></tt-input-number>
                <tt-button-save ttText="kpicomp_save" [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
            </tt-card>

            <tt-card class="col-xs-12 p-4" ttHeading="link" ttIcon="far fa-link">
                <tt-input ttLabel="goto_item_state" [(ttModel)]="get.goto_item_state"></tt-input>
                <tt-input ttLabel="goto_item_parms" [(ttModel)]="get.goto_item_parms"></tt-input>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-3 sp-0">
            <tt-card class="col-xs-12 p-4" ttHeading="tile_heading_text" ttIcon="far fa-h1">
                <tt-input ttLabel="tile_heading_text" [(ttModel)]="get.tile_heading_text">
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="fas fa-language" (ttClick)="openTranslateDialog(get.tile_heading_text_word_id, get.tile_heading_text)"></tt-form-field-button>
                    </ng-container>
                </tt-input>
                <tt-color-input ttLabel="tile_heading_text_color" [(ttModel)]="get.tile_heading_text_color" ttDebounceTime="50"></tt-color-input>
                <tt-select ttLabel="fontsize" [(ttModel)]="get.tile_heading_text_size" [ttData]="fontSizes"></tt-select>
            </tt-card>

            <tt-card class="col-xs-12 p-4" ttHeading="tile_subheading_text" ttIcon="far fa-h2">
                <tt-input ttLabel="tile_subheading_text" [(ttModel)]="get.tile_subheading_text">
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="fas fa-language" (ttClick)="openTranslateDialog(get.tile_subheading_text_word_id, get.tile_subheading_text)"></tt-form-field-button>
                    </ng-container>
                </tt-input>
                <tt-color-input ttLabel="tile_subheading_text_color" [(ttModel)]="get.tile_subheading_text_color" ttDebounceTime="50"></tt-color-input>
                <tt-select ttLabel="fontsize" [(ttModel)]="get.tile_subheading_text_size" [ttData]="fontSizes"></tt-select>
            </tt-card>

            <tt-card class="col-xs-12 p-4" ttHeading="item_glyphicon" ttIcon="far fa-icons">
                <tt-input class="kpicomp__heading-input" ttLabel="item_glyphicon" [(ttModel)]="get.item_glyphicon"></tt-input>
                <tt-color-input ttLabel="item_glyphicon_color" [(ttModel)]="get.item_glyphicon_color" ttDebounceTime="50"></tt-color-input>
                <tt-select ttLabel="fontsize" [(ttModel)]="get.item_glyphicon_size" [ttData]="fontSizes"></tt-select>
            </tt-card>
        </div>
        <div class="col-md-6 sp-0">
            <tt-dashboard-widget-base class="col-md-6 p-8" style="width: 40rem" [ttDashboardWidget]="$any(get)"></tt-dashboard-widget-base>
            <div class="col-xs-12 sp-0">
                <tt-card class="col-xs-12 col-md-6 p-4" ttHeading="h_slicers" ttIcon="far fa-filter">
                    <tt-list ttCheckboxSelection (ttCheckboxSelectionChanged)="onSlicersChanged($event)" ttButtonsPosition="right" [ttData]="slicers" [ttButtons]="buttons"> </tt-list>
                </tt-card>
            </div>
        </div>
    </div>
    <tt-grid *ngIf="!!grid" class="col-xs-12 sp-0 flex-1" style="min-height: 500px" [(ttOptions)]="grid"></tt-grid>
</tt-page>
